module.exports = __webpack_public_path__ + "img/close.b9f7d25b.svg";